module.exports = __webpack_public_path__ + "static/media/John_K@3x.1bc4c98e.jpg";